export default __webpack_public_path__ + "static/media/Chiesi-logo.03165c78.jpg";